// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let  ControlAlertCommandMessage = function (fieldSet)
{
    this.Code = Message.CODE_CONTROL_ALERT_COMMAND_MESSAGE
    PFixMessage.call(this, fieldSet)
}
ControlAlertCommandMessage.prototype = Object.create(PFixMessage.prototype)

ControlAlertCommandMessage.prototype.getAlertId = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_ID)
}

ControlAlertCommandMessage.prototype.setAlertId = function (alertId)
{
    this.setFieldValue(FieldsFactory.FIELD_ALERT_ID, alertId)
}

ControlAlertCommandMessage.prototype.getAlertCommand = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ALERT_COMMAND)
}

ControlAlertCommandMessage.prototype.setAlertCommand = function (alertCommand)
{
    this.setFieldValue(FieldsFactory.FIELD_ALERT_COMMAND, alertCommand)
}